import { useState, useEffect } from 'react'

export default function CustomCursor() {
  const [cursorXY, setCursorXY] = useState({ x: -100, y: -100 })
  useEffect(() => {
    const moveCursor = (e: MouseEvent) => {
      const x = e.clientX - 20
      const y = e.clientY - 20
      setCursorXY({ x, y })
    }
    window.addEventListener('mousemove', moveCursor)
    return () => {
      window.removeEventListener('mousemove', moveCursor)
    }
  }, [])
  return (
    <div
      className='cursor duration-100 ease-in-out border border-neutral-300 dark:border-neutral-600'
      style={{
        transform: `translate3d(${cursorXY.x}px, ${cursorXY.y}px, 0)`,
      }}></div>
  )
}
